import { createApp, h } from 'vue'
import HelloworkOrder from '../hellowork_order'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('hellowork_order')
  const props = JSON.parse(el.getAttribute('data-props'))
  createApp({
    render: () => h(HelloworkOrder, props)
  }).mount(el)
})
